"use client";

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from "react";
import BrainMobileAbout from "./BrainMobileAbout";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWave } from "@/generated/models/ApiWave";
import MyStreamWaveLeaderboard from "../my-stream/MyStreamWaveLeaderboard";
import MyStreamWaveSubmissions from "../my-stream/MyStreamWaveSubmissions";
import MyStreamWaveOutcome from "../my-stream/MyStreamWaveOutcome";
import MyStreamWaveSales from "../my-stream/MyStreamWaveSales";
import MyStreamWaveMyVotes from "../my-stream/votes/MyStreamWaveMyVotes";
import MyStreamWaveFAQ from "../my-stream/MyStreamWaveFAQ";
import BrainMobileWaves from "./BrainMobileWaves";
import BrainMobileMessages from "./BrainMobileMessages";
import BrainNotifications from "../notifications/NotificationsContainer";
import { WaveWinners } from "@/components/waves/winners/WaveWinners";
import { BrainView } from "./brainMobileViews";
interface BrainMobileViewContentProps {
  readonly activeView: BrainView;
  readonly activeWaveId: string | null;
  readonly children: ReactNode;
  readonly isCurationWave: boolean;
  readonly isMemesWave: boolean;
  readonly isRankWave: boolean;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly onOpenQuickVote: () => void;
  readonly onPrefetchQuickVote?: (() => void) | undefined;
  readonly wave: ApiWave | null | undefined;
}
export default function BrainMobileViewContent(t0) {
  const $ = _c(38);
  const {
    activeView,
    activeWaveId,
    children,
    isCurationWave,
    isMemesWave,
    isRankWave,
    onDropClick,
    onOpenQuickVote,
    onPrefetchQuickVote,
    wave
  } = t0;
  const rankWave = isRankWave ? wave ?? null : null;
  const curationWave = isCurationWave ? wave ?? null : null;
  const faqWave = isRankWave && isMemesWave ? wave ?? null : null;
  let t1;
  if ($[0] !== onDropClick || $[1] !== rankWave) {
    t1 = rankWave ? <MyStreamWaveLeaderboard key={rankWave.id} wave={rankWave} onDropClick={onDropClick} /> : null;
    $[0] = onDropClick;
    $[1] = rankWave;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const leaderboardContent = t1;
  let t2;
  if ($[3] !== onDropClick || $[4] !== rankWave) {
    t2 = rankWave ? <MyStreamWaveSubmissions key={rankWave.id} wave={rankWave} onDropClick={onDropClick} /> : null;
    $[3] = onDropClick;
    $[4] = rankWave;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const submissionsContent = t2;
  let t3;
  if ($[6] !== curationWave) {
    t3 = curationWave ? <MyStreamWaveSales waveId={curationWave.id} /> : null;
    $[6] = curationWave;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const salesContent = t3;
  let t4;
  if ($[8] !== onDropClick || $[9] !== rankWave) {
    t4 = rankWave ? <div className="tw-px-2 sm:tw-px-4"><WaveWinners wave={rankWave} onDropClick={onDropClick} /></div> : null;
    $[8] = onDropClick;
    $[9] = rankWave;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const winnersContent = t4;
  let t5;
  if ($[11] !== rankWave) {
    t5 = rankWave ? <MyStreamWaveOutcome wave={rankWave} /> : null;
    $[11] = rankWave;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const outcomeContent = t5;
  let t6;
  if ($[13] !== onDropClick || $[14] !== rankWave) {
    t6 = rankWave ? <MyStreamWaveMyVotes wave={rankWave} onDropClick={onDropClick} /> : null;
    $[13] = onDropClick;
    $[14] = rankWave;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const myVotesContent = t6;
  let t7;
  if ($[16] !== faqWave) {
    t7 = faqWave ? <MyStreamWaveFAQ wave={faqWave} /> : null;
    $[16] = faqWave;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const faqContent = t7;
  let t8;
  if ($[18] !== children) {
    t8 = <>{children}</>;
    $[18] = children;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== activeWaveId) {
    t9 = <BrainMobileAbout activeWaveId={activeWaveId} />;
    $[20] = activeWaveId;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== onOpenQuickVote || $[23] !== onPrefetchQuickVote) {
    t10 = <BrainMobileWaves onOpenQuickVote={onOpenQuickVote} onPrefetchQuickVote={onPrefetchQuickVote} />;
    $[22] = onOpenQuickVote;
    $[23] = onPrefetchQuickVote;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <BrainMobileMessages />;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <BrainNotifications />;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== faqContent || $[28] !== leaderboardContent || $[29] !== myVotesContent || $[30] !== outcomeContent || $[31] !== salesContent || $[32] !== submissionsContent || $[33] !== t10 || $[34] !== t8 || $[35] !== t9 || $[36] !== winnersContent) {
    t13 = {
      [BrainView.DEFAULT]: t8,
      [BrainView.ABOUT]: t9,
      [BrainView.LEADERBOARD]: leaderboardContent,
      [BrainView.SUBMISSIONS]: submissionsContent,
      [BrainView.SALES]: salesContent,
      [BrainView.WINNERS]: winnersContent,
      [BrainView.OUTCOME]: outcomeContent,
      [BrainView.MY_VOTES]: myVotesContent,
      [BrainView.FAQ]: faqContent,
      [BrainView.WAVES]: t10,
      [BrainView.MESSAGES]: t11,
      [BrainView.NOTIFICATIONS]: t12
    };
    $[27] = faqContent;
    $[28] = leaderboardContent;
    $[29] = myVotesContent;
    $[30] = outcomeContent;
    $[31] = salesContent;
    $[32] = submissionsContent;
    $[33] = t10;
    $[34] = t8;
    $[35] = t9;
    $[36] = winnersContent;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  const contentByView = t13;
  return contentByView[activeView];
}